import { Inject, Injectable } from '@angular/core';
import { TInputAppEnvironmentVars } from '@monorepo/types';

export const FabricInspectionEndPoints = {
  DEFECTS_LISTING_V2: '',
  ROLLS_INFO: 'ROLLS_INFO',
  LOT_LISTING: 'LOT_LISTING',
  LOT_DETAIL: 'LOT_DETAIL',
  FI_CONFIG: 'FI_CONFIG',
  START_OR_UPDATE_LOT_INSPECTION: '',
  REOPEN_LOT_INSPECTION: '',
  UPDATE_ROLL_STATUS: '',
  CHANGE_ROLL_STATUS: '',
  ROLL_INSPECTION_SYNC: '',
  LOT_COMPLETION: '',
  UPDATE_ROLL_INSPECTION_RESULT: '',
  SPLIT_ROLL: '',
  COMMENT_ON_ROLL: '',
  COMMENT_ON_LOT: '',
  GET_TEST_REPORT: '',
  SEARCH_BCTX: '',
  GET_LOT_DETAILS_BY_GRNTAG: '',
};

type TFabricInspectionEndPoints = typeof FabricInspectionEndPoints;
type TFabricInspectionEndPointsTypes = keyof TFabricInspectionEndPoints;

@Injectable({ providedIn: 'root' })
export class FabricInspectionEnvService {
  public mode = 'dev';

  HOST_DOMAIN;
  HOST_DOMAIN_WITH_PROTOCOL;

  private env_vars: TFabricInspectionEndPoints = {
    DEFECTS_LISTING_V2: '',
    ROLLS_INFO: '',
    LOT_LISTING: '',
    LOT_DETAIL: '',
    FI_CONFIG: '',
    START_OR_UPDATE_LOT_INSPECTION: '',
    REOPEN_LOT_INSPECTION: '',
    UPDATE_ROLL_STATUS: '',
    CHANGE_ROLL_STATUS: '',
    ROLL_INSPECTION_SYNC: '',
    LOT_COMPLETION: '',
    UPDATE_ROLL_INSPECTION_RESULT: '',
    SPLIT_ROLL: '',
    COMMENT_ON_ROLL: '',
    COMMENT_ON_LOT: '',
    GET_TEST_REPORT: '',
    SEARCH_BCTX: '',
    GET_LOT_DETAILS_BY_GRNTAG: '',
  };

  constructor(@Inject('environment') environment: TInputAppEnvironmentVars) {
    if (environment.mode) {
      this.mode = environment.mode;
    }

    this.HOST_DOMAIN = environment.service_host;
    this.HOST_DOMAIN_WITH_PROTOCOL = environment.protocol + this.HOST_DOMAIN;
    this.registerVars();
  }

  private registerVars() {
    this.env_vars.DEFECTS_LISTING_V2 =
      this.HOST_DOMAIN_WITH_PROTOCOL + '/core_services/ext/api/v1/fabricDefects/getFabricDefects';

    this.env_vars.ROLLS_INFO = this.HOST_DOMAIN_WITH_PROTOCOL + '/fabric_inspection/ext/v1/roll/getRollsCountInfo';

    // TODO: params lotListingType
    this.env_vars.LOT_LISTING = this.HOST_DOMAIN_WITH_PROTOCOL + '/fabric_inspection/ext/v1/lot/listing/';

    this.env_vars.LOT_DETAIL = this.HOST_DOMAIN_WITH_PROTOCOL + '/fabric_inspection/ext/v1/lot/details';

    this.env_vars.FI_CONFIG = this.HOST_DOMAIN_WITH_PROTOCOL + '/fabric_inspection/ext/v1/fi/config/';

    this.env_vars.START_OR_UPDATE_LOT_INSPECTION =
      this.HOST_DOMAIN_WITH_PROTOCOL + '/fabric_inspection/ext/v1/lot/startOrUpdateInspection';

    this.env_vars.REOPEN_LOT_INSPECTION =
      this.HOST_DOMAIN_WITH_PROTOCOL + '/fabric_inspection/ext/v1/lot/reopenInspection';

    this.env_vars.UPDATE_ROLL_STATUS = this.HOST_DOMAIN_WITH_PROTOCOL + '/fabric_inspection/ext/v1/roll/updateStatus';

    this.env_vars.CHANGE_ROLL_STATUS = this.HOST_DOMAIN_WITH_PROTOCOL + '/fabric_inspection/ext/v1/roll/changeStatus';

    this.env_vars.ROLL_INSPECTION_SYNC =
      this.HOST_DOMAIN_WITH_PROTOCOL + '/fabric_inspection/ext/v1/roll/syncInspection';

    this.env_vars.LOT_COMPLETION = this.HOST_DOMAIN_WITH_PROTOCOL + '/fabric_inspection/ext/v1/lot/completeInspection';

    this.env_vars.SPLIT_ROLL = this.HOST_DOMAIN_WITH_PROTOCOL + '/fabric_inspection/ext/v1/roll/splitRoll/input-app';

    this.env_vars.COMMENT_ON_ROLL =
      this.HOST_DOMAIN_WITH_PROTOCOL + '/fabric_inspection/ext/v1/roll/addCommentForInspectedRoll ';

    this.env_vars.COMMENT_ON_LOT = this.HOST_DOMAIN_WITH_PROTOCOL + '/fabric_inspection/ext/v1/lot/addLotLevelComment';

    this.env_vars.GET_TEST_REPORT = this.HOST_DOMAIN_WITH_PROTOCOL + '/fabric_inspection/ext/v1/download/testReport';
    this.env_vars.SEARCH_BCTX = this.HOST_DOMAIN_WITH_PROTOCOL + '/fabric_inspection/ext/v1/transaction/searchBCTX';

    this.env_vars.GET_LOT_DETAILS_BY_GRNTAG =
      this.HOST_DOMAIN_WITH_PROTOCOL + '/fabric_inspection/ext/api/v1/wms/fabricInspection/grn/getFabricLotDetails';
  }

  public getEnvVar(arg: TFabricInspectionEndPointsTypes): string {
    return this.env_vars[arg];
  }
}
